import { useContext } from 'react';

import { ToastContext } from '.';

export const useToast = () => useContext(ToastContext);
